module.exports = __webpack_public_path__ + "../static/img/vending.8413d50b.png";